import { createAction } from 'redux-actions'
const prefix = 'Optimizely:'

export const SET_OPTIMIZELY_SESSION_ID = `${prefix} Set Optimizely session id`
export const SET_OPTIMIZELY_ATTRIBUTES = `${prefix} Set Optimizely attributes`
export const SET_OPTIMIZELY_LOGGER_ENABLED = `${prefix} Set Optimizely logger enabled`
export const SET_OPTIMIZELY_ENABLED_FEATURES = `${prefix} Set Optimizely enabled features`

export const setOptimizelySessionId = createAction(SET_OPTIMIZELY_SESSION_ID)
export const setOptimizelyAttributes = createAction(SET_OPTIMIZELY_ATTRIBUTES)
export const setOptimizelyLoggerEnabled = createAction(SET_OPTIMIZELY_LOGGER_ENABLED)
export const setOptimizelyEnabledFeatures = createAction(SET_OPTIMIZELY_ENABLED_FEATURES)
